module.exports = __webpack_public_path__ + "img/volume-down.f5b85440.svg";